<template>
  <div
    class="c-membership"
    :class="[accentClass]"
  >
    <h2
      v-if="body.title.toLowerCase() === 'mensual'"
      class="c-membership__title mb-0 py-3"
    >
      {{body.title}}
    </h2>
    <h2
      v-if="body.title.toLowerCase() === 'anual'"
      class="c-membership__title mb-0 py-3"
    >
      Más popular
    </h2>
    <div class="c-membership__container p-3 pt-0">
      <div
        v-if="body.title.toLowerCase() === 'mensual'"
        class="c-hr c-hr--sec-medium mb-3"></div>
      <div v-else-if="body.title.toLowerCase() === 'anual'">
        <h2 class="w-bold bg-sec-color white fs-21 my-3">
          {{body.title}}
        </h2>
        <div class="c-hr c-hr--sec-medium mb-3"></div>
      </div>
      <div class="d-flex flex-column align-items-start">
        <p v-if="body.has_discount" class="gray-text fs-21 w-sbold mb-0">
          Antes {{currency}}
          <span class="fs-21 w-sbold">
            <del>
              {{beforeAmount.toFixed(2)}}
            </del>
            <span class="fs-18 ms-2">
              <del>/ mes</del>
            </span>
          </span>
        </p>
        <p v-else class="sec-color fs-21 w-sbold mb-0">
          -
        </p>

        <p class="white w-sbold mb-0">
          {{currency}}
          <span class="fs-35 w-sbold">
            {{currentAmount.toFixed(2)}}
            <span class="fs-25">
              / mes
            </span>
          </span>
        </p>
        <p class="text-center fs-21 white w-medium">
          <template>
            Precio final {{currency}} {{body.amounts.current.toFixed(2)}}
          </template>
        </p>
      </div>
      <button
        @click="goToCheckout()"
        :class="{'c-button--primary-ghost' : body.title.toLowerCase() === 'mensual'}"
        class="c-button c-button--primary w-100
          py-2 justify-content-center"
      >
        Vuélvete premium
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['variant', 'plan', 'body', 'subscriber'],
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userData() {
      return this.$store.getters.stateUser;
    },

    accentClass() {
      return (this.variant) ? `c-membership--${this.variant}` : '';
    },
    currency() {
      return this.body.amounts.symbol;
    },

    beforeAmount() {
      if (this.body.title.toLowerCase() === 'anual') {
        return this.body.amounts.before / 12;
      }

      return this.body.amounts.before;
    },
    currentAmount() {
      if (this.body.title.toLowerCase() === 'anual') {
        return this.body.amounts.current / 12;
      }

      return this.body.amounts.current;
    },
  },
  methods: {
    goToCheckout() {
      this.$router.push({
        path: this.body.button.path,
      }).catch(() => {});
    },
  },
};
</script>
